import React, { useEffect, useRef, useState } from "react";
import './datepicker-textfield.css'
import moment from "moment";
import { values } from "lodash";


function DatepickerTextfield(props) {

    const [dateTextfield, setDateTextfield] = useState('');
    const [error, setError] = useState('');
    // console.log('props.updatedDate', props.updatedDate);

    const datefield = props.dateField;
    const updatedate = props.updatedDate;
    const mindate = props.minDateField;
    const maxdate = props.maxDateField;
    const memberType = props.memberType
    const onUpdateDatePicker = props.onUpdateDatePicker

    const textFieldRef = useRef(null)


    const handleTextData = (event) => {

        let value = event.target.value;
        // validateDOB(value)
        let onlyNumber = /^[0-9]+$/;
        let modifedValue = value.replaceAll('-', '');
        let validDate = onlyNumber.test(modifedValue);
        if (validDate || value === "") {
            if (dateTextfield.length === 1 && value.length === 2) {
                value = value.slice(0, 2) + '-' + value.slice(2);
            }
            if (dateTextfield.length === 4 && value.length === 5) {
                value = value.slice(0, 5) + '-' + value.slice(5);
            }
            let date = value.split("-")
            if((date[0].length > 1 && Number(date[0]) > 31) || (date[0] === "00" && date[0].length == 2) ) {
                return
            }

            if(date[1]) {
                if((date[1].length > 1 && Number(date[1]) > 12) || (date[1] === "00" && date[1].length == 2) ) {
                    return
                }
            }
            let lastYear = ""
            if (maxdate) {
                lastYear = moment(maxdate).year();
            } else {
                let yearDiff = moment().year()
                lastYear = moment().subtract(yearDiff - 1900, 'years').year();
            }

            if(date[2]){
                let currentYear = moment().year()
                if((Number(date[2]) > Number(currentYear))) {
                    value = value.slice(0, -1)
                }
            }
            setDateTextfield(value);
        }

    };

    useEffect(() => {

        if (datefield) {
            let formatDate = datefield
            const validateDate = moment(datefield, 'DD-MM-YYYY', true).isValid()

            if(!validateDate) {
                formatDate = moment(datefield).format('DD-MM-YYYY');
            }

            setDateTextfield(formatDate);
        }
        textFieldRef.current.focus();
    }, [])

    useEffect(() => {

        if (updatedate) {
            if(updatedate !== "Invalid date") {
                let isValidDate = moment(updatedate, 'DD-MM-YYYY', true).isValid()
                if ((!isValidDate || updatedate.includes('-')) && !updatedate.includes('0000')) {
                    let formatDate = updatedate
                    // if(!updatedate.includes('-')) {
                    //     formatDate = moment(updatedate).format('DD-MM-YYYY');
                    // }
                    // validateDOB(formatDate)
                    setDateTextfield(formatDate);
                }
            } else {
                // if(mindate) {
                //     setDateTextfield(moment(mindate).format('DD-MM-YYYY'));
                // } else if(maxdate) {
                //     setDateTextfield(moment().format('DD-MM-YYYY'));
                // }
            }
            
        }
    }, [updatedate])

    useEffect(() => {
        // if (dateTextfield.length === 10 && !error) {
            props.handleDatePickerDropDown(dateTextfield);
        // }

    }, [dateTextfield])

    useEffect(() => {
        props.handleDatePickerError(error);
    }, [error])

    function validateDOB(value) {
        let modifedDate = moment(value, 'DD-MM-YYYY').format("YYYY-MM-DD")
        let years = moment().diff(moment(modifedDate), 'years')
        // var years = age.years();
        let validate = moment(value, 'DD-MM-YYYY', true).isValid();

        if (validate) {
            if (mindate) {
                let yearDiff = moment().year()
                let yearDiff1 = moment(modifedDate).year()

                let lastYear = moment().subtract(yearDiff - 1900, 'years').year();
                if (years < 18) {
                    setError('Please enter the age more than 18 years')
                    
                } else if(lastYear > yearDiff1) {
                    setError('Please enter eligible date')
                } else {
                    setError('')
                }

            } else if (maxdate) {
                if ((years > 18 || !moment().isAfter(moment(modifedDate))) && memberType !== "CHILD") {
                    setError('Please enter the age less than 18 years')

                } else {
                    setError('')
                }
            }
            setDateTextfield(value);

        } else {
            setError('Please enter a valid Date of Birth');
        }
    }

    return (
        <div>
            <input
                className="datepicker-text"
                type="text"
                placeholder="DD-MM-YYYY"
                name="datepicker-textfield"
                value={dateTextfield}
                onChange={handleTextData}
                // onBlur={validateDOB}
                maxLength="10" 
                onKeyDown={(e) => { 
                    if(e.keyCode === 189) {
                        e.preventDefault();
                        return
                    }
                    if (e.keyCode === 13) {
                        onUpdateDatePicker()
                    }
                }}
                ref={textFieldRef}
                // onBlur={()=>(validateDOB(dateTextfield))}
                />
            {props.error1 && <p className="error">{props.error1}</p>}
        </div>
    )
}

export default DatepickerTextfield;